import { render, staticRenderFns } from "./PictionaryPage.vue?vue&type=template&id=557717f6&scoped=true&"
import script from "./PictionaryPage.vue?vue&type=script&lang=js&"
export * from "./PictionaryPage.vue?vue&type=script&lang=js&"
import style0 from "./PictionaryPage.vue?vue&type=style&index=0&id=557717f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557717f6",
  null
  
)

export default component.exports